import {mapGetters, mapMutations} from "vuex";
import {directive as onClickaway} from 'vue-clickaway';

export default {
    name: 'auth-mobile-navigation',
    directives: {
        onClickaway: onClickaway,
    },
    data() {
        return {
            label: '',
            isNavigationRoute: false,
            isSocialActive: false
        }
    },
    computed: {
        ...mapGetters({
            openMobileMenu: 'system/openMenu',
            currentCountry: 'setting/currentCountry',
        }),
        showArrowBack() {
            if (this.$route.name === 'sing-in' || this.$route.name === 'registration') {
                return true
            }
            return false
        }
    },
    methods: {
        ...mapMutations({
            changeMobileMenu: 'system/CHANGE_MOBILE_MENU'
        }),
        changeAction(val) {
            if (val) {
                this.$router.push({name: 'sing-in'});
            } else {
                this.changeMobileMenu(!this.openMobileMenu)
            }
        },
        closeSocial() {
            this.isSocialActive = false
        }
    }
}
